function Icon(props) {
  const className = props.className ? `icon ${props.className}` : 'icon'
  const coordinateX = props.coordinateX || 0
  const coordinateY = props.coordinateY || 0
  const strokeWidth = props.strokeWidth ? props.strokeWidth : 1
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox={props.viewBox} fill="none" stroke-width={strokeWidth}>
      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#${props.name}`} x={coordinateX} y={coordinateY} />
    </svg>
  )
}

export default Icon
